module.exports = __webpack_public_path__ + "static/img/bar4@2x.c71ebd77.png";